import React from 'react';
import { useNavigate } from 'react-router-dom';

const expertises = [
  {
    id: 'ppf-wrap',
    title: 'PPF Wrap',
    image: 'https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images/ppfwraps.jpg',
  },
  {
    id: 'chiptuning',
    title: 'Chiptuning',
    image: 'https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images/GP%20Products-11.jpg',
  },
  {
    id: 'modificaties',
    title: 'Modificaties',
    image: 'https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images/mods.jpg',
  },
  {
    id: 'tuning-kits',
    title: 'Tuning Kits',
    image: 'https://lozejxkhsvwkksgzhrfd.supabase.co/storage/v1/object/public/images/tuningkits.jpg',
  },
];

const ExpertiseCards = () => {
  const navigate = useNavigate();

  return (
    <section className="bg-[#f2f2f0] py-20 md:py-28 lg:py-32">
      <div className="max-w-[1400px] mx-auto px-8 md:px-12 lg:px-16">
        {/* Header row */}
        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-6 mb-12 md:mb-16">
          <h2
            className="text-black text-3xl md:text-4xl lg:text-[2.75rem] font-medium tracking-[0.08em] leading-[1.1]"
            style={{ fontFamily: "'Manrope', sans-serif" }}
          >
            ONZE EXPERTISES
          </h2>
          <div className="flex items-center gap-4">
            <button
              onClick={() => navigate('/expertises')}
              className="bg-black text-white text-xs tracking-[0.1em] uppercase px-6 py-3 rounded-full flex items-center gap-2 hover:bg-black/85 transition-colors"
              style={{ fontFamily: "'Manrope', sans-serif", fontWeight: 500 }}
            >
              Bekijk al onze expertises
            </button>
          </div>
        </div>

        {/* Cards grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {expertises.map((item) => (
            <div
              key={item.id}
              onClick={() => navigate(`/expertises/${item.id}`)}
              className="cursor-pointer group"
            >
              <div className="w-full aspect-[2/3] rounded-2xl overflow-hidden mb-5">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <h3
                className="text-black text-sm font-semibold tracking-[0.08em] text-center uppercase"
                style={{ fontFamily: "'Manrope', sans-serif" }}
              >
                {item.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExpertiseCards;
